export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9049.5d2c5281.jpg";